import type { SVGProps } from 'react';

const SvgIsolatedPools = (props: SVGProps<SVGSVGElement>) => (
    <svg fill="#fff" version="1.1" id="Vrstva_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    viewBox="0 0 57.73 57.54" {...props}>

<g>
   <g>
       <path d="M27.31,17.7H10.52c-4.48,0-8.12-3.63-8.12-8.12v0c0-4.48,3.63-8.12,8.12-8.12h16.79
           c4.48,0,8.12,3.63,8.12,8.12v0C35.43,14.06,31.8,17.7,27.31,17.7z"/>
   </g>
   <g>
       <path d="M46.53,17.7L46.53,17.7c-4.48,0-8.12-3.63-8.12-8.12v0c0-4.48,3.63-8.12,8.12-8.12h0
           c4.48,0,8.12,3.63,8.12,8.12v0C54.65,14.06,51.02,17.7,46.53,17.7z"/>
   </g>
</g>
<g>
   <g>
       <path d="M27.31,55.39H10.52c-4.48,0-8.12-3.63-8.12-8.12v0c0-4.48,3.63-8.12,8.12-8.12h16.79
           c4.48,0,8.12,3.63,8.12,8.12v0C35.43,51.75,31.8,55.39,27.31,55.39z"/>
   </g>
   <g>
       <path d="M46.53,55.39L46.53,55.39c-4.48,0-8.12-3.63-8.12-8.12v0c0-4.48,3.63-8.12,8.12-8.12h0
           c4.48,0,8.12,3.63,8.12,8.12v0C54.65,51.75,51.02,55.39,46.53,55.39z"/>
   </g>
</g>
<g>
   <g>
       <path d="M29.74,20.31h16.79c4.48,0,8.12,3.63,8.12,8.12v0c0,4.48-3.63,8.12-8.12,8.12H29.74
           c-4.48,0-8.12-3.63-8.12-8.12v0C21.62,23.94,25.26,20.31,29.74,20.31z"/>
   </g>
   <g>
       <path d="M10.52,20.31L10.52,20.31c4.48,0,8.12,3.63,8.12,8.12v0c0,4.48-3.63,8.12-8.12,8.12h0
           c-4.48,0-8.12-3.63-8.12-8.12v0C2.41,23.94,6.04,20.31,10.52,20.31z"/>
   </g>
</g>
</svg>

);

export default SvgIsolatedPools;
